(() => {
  const selector = '.jdgm-carousel-item__product-image';

  const enhance = (root = document) => {
    const images = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];

    images.forEach((image) => {
      if (!image.hasAttribute('width')) image.width = 500;
      if (!image.hasAttribute('height')) image.height = 500;
      image.loading = 'lazy';
      image.decoding = 'async';
    });
  };

  const initialize = () => {
    enhance();
    if (!('MutationObserver' in window)) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) enhance(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
